import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class ReportSurfacesApi extends BaseApi {
    constructor(client) { super(client, '/report-surfaces'); }

    async describeMany(surfaceKeys) {
        try {
            const query = surfaceKeys.map(encodeURIComponent).join(',');
            return (await this.client.get(`${this.basePath}?surfaceKeys=${query}`)).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async describe(surfaceKey) {
        try {
            return (await this.client.get(`${this.basePath}/${encodeURIComponent(surfaceKey)}`)).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
